// Performance monitoring utilities for WebSocket optimization
class PerformanceMonitor {
  constructor() {
    this.metrics = {
      websocketMessages: 0,
      memoryLeaks: 0,
      connectionDrops: 0,
      slowResponses: 0
    };
    this.startTime = Date.now();
  }

  // Track WebSocket message processing
  trackWebSocketMessage(processingTime) {
    this.metrics.websocketMessages++;
    
    if (processingTime > 1000) {
      this.metrics.slowResponses++;
      console.warn(`Slow WebSocket message processing: ${processingTime}ms`);
    }
  }

  // Track memory usage
  trackMemoryUsage() {
    if (typeof window !== 'undefined' && window.performance && window.performance.memory) {
      const memory = window.performance.memory;
      const usage = {
        used: Math.round(memory.usedJSHeapSize / 1024 / 1024),
        total: Math.round(memory.totalJSHeapSize / 1024 / 1024),
        limit: Math.round(memory.jsHeapSizeLimit / 1024 / 1024),
        percentage: Math.round((memory.usedJSHeapSize / memory.jsHeapSizeLimit) * 100)
      };

      // Detect potential memory leaks
      if (usage.percentage > 80) {
        this.metrics.memoryLeaks++;
        console.warn('High memory usage detected:', usage);
      }

      return usage;
    }
    return null;
  }

  // Track connection quality
  trackConnectionQuality(quality, responseTime) {
    if (quality === 'poor' || responseTime > 5000) {
      this.metrics.connectionDrops++;
      console.warn(`Poor connection quality: ${quality}, response time: ${responseTime}ms`);
    }
  }

  // Get performance summary
  getPerformanceSummary() {
    const uptime = Date.now() - this.startTime;
    const summary = {
      uptime: Math.round(uptime / 1000),
      ...this.metrics,
      averageMessageTime: this.metrics.websocketMessages > 0 ? 
        Math.round((uptime / this.metrics.websocketMessages)) : 0
    };

    console.log('Performance Summary:', summary);
    return summary;
  }

  // Reset metrics
  reset() {
    this.metrics = {
      websocketMessages: 0,
      memoryLeaks: 0,
      connectionDrops: 0,
      slowResponses: 0
    };
    this.startTime = Date.now();
  }
}

// Create singleton instance
const performanceMonitor = new PerformanceMonitor();

export default performanceMonitor;
